import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_SUBSCRIPTIONS } from "../../../config/api";

export const getIpoSubscriptions = createAsyncThunk(
  "ipos/getSubscriptions",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_IPO_SUBSCRIPTIONS(id),
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
